function CTA() {
  return (
    <div className="cta">
      <a
        rel="noreferrer"
        target="_blank"
        href="https://drive.google.com/file/d/1IRuHOlfzLIXvvayXU5DvQx0Vwz4Le12V/view?usp=sharing"
        className="btn"
      >
        Download Resume
      </a>
      <a href="#contact" className="btn btn-primary">
        Let's Talk
      </a>
    </div>
  );
}

export default CTA;
